/* eslint-disable no-unused-vars */
import { useCallback, useState } from 'react'
import { useNavigate, NavigateFunction } from 'react-router-dom'
import moment from 'moment'

import { t } from '@/i18n'
import { useDriverQuery } from '@/apollo/graphql'
import { IDriver, TFormSubmit } from '@/types'
import { useAPI, useToast } from '@/hooks/index'
import { homePath, transformData } from '@/utils/index'

interface IUseData {
  id?: string
}

export const useData = ({ id }: IUseData) => {
  const navigate: NavigateFunction = useNavigate()
  const addToast = useToast()
  const { submitting, sendForm } = useAPI()
  const [data, setData] = useState<any>({})

  const { loading } = useDriverQuery({
    skip: !id,
    fetchPolicy: 'network-only',
    variables: {
      id: id || '',
    },
    onCompleted: res => {
      if (res.driver) {
        setData(res.driver)
      }
    },
  })

  const onSubmit: TFormSubmit<{ driver: IDriver; driver_id?: string }> =
    useCallback(
      (path, isEdit, callback) => d => {
        if (d.driver.birthday) {
          d.driver.birthday = moment(d.driver.birthday).format('YYYY-MM-DD')
        }

        sendForm(
          {
            path,
            method: isEdit ? 'PUT' : 'POST',
            data: { driver: transformData(d.driver), driver_id: d.driver_id },
            callback,
          },
          { showNotify: true },
        )
      },
      [sendForm],
    )

  const onCancel = useCallback(() => {
    navigate(homePath)
  }, [navigate])

  const onDelete = useCallback(
    (id: string) => {
      sendForm(
        {
          path: `cars/drivers/${id}/`,
          method: 'DELETE',
          data: undefined,
          callback: () => {
            addToast('success', t('success'))
            navigate(-1)
          },
        },
        {
          showNotify: false,
        },
      )
    },
    [addToast, navigate, sendForm],
  )

  return {
    loading,
    submitting,
    data,
    onSubmit,
    onCancel,
    onDelete,
  }
}
